import React from 'react';

function ConsultarPropietario() {
  return <h1>Consulta de Propietario de Vehículo</h1>;
}

export default ConsultarPropietario;
